// ─── Color Palette (exact match reference) ───
export const C = {
  bg: "#f8f9fb", card: "#ffffff", border: "#e8ecf1", borderLight: "#f0f2f5",
  text: "#1a2332", textMid: "#4a5568", textLight: "#8896a6",
  accent: "#0066cc", accentLight: "#e8f2ff", accentBg: "#f0f7ff",
  green: "#059669", greenLight: "#ecfdf5", greenBorder: "#a7f3d0",
  red: "#dc2626", redLight: "#fef2f2",
  purple: "#7c3aed", purpleLight: "#f5f3ff",
  blue: "#2563eb", blueLight: "#eff6ff",
  orange: "#d97706", orangeLight: "#fffbeb",
};

// ─── Shared Styles ───
export const S = {
  label: { display: "block", fontSize: 11, fontWeight: 600, color: C.textMid, marginBottom: 4, letterSpacing: "0.02em" },
  input: { width: "100%", padding: "8px 12px", background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, color: C.text, fontSize: 14, fontWeight: 600, fontFamily: "'JetBrains Mono', monospace", outline: "none", boxSizing: "border-box" },
  select: { width: "100%", padding: "8px 12px", background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, color: C.text, fontSize: 14, fontWeight: 600, fontFamily: "'Inter', sans-serif", outline: "none", boxSizing: "border-box", cursor: "pointer", appearance: "none" },
  card: { background: C.card, borderRadius: 12, padding: "20px", border: `1px solid ${C.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" },
  heading: { fontSize: 11, fontWeight: 700, color: C.textLight, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px", fontFamily: "'JetBrains Mono', monospace" },
  th: { padding: "8px 10px", textAlign: "left", fontSize: 10, fontWeight: 700, color: C.textLight, textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: `2px solid ${C.border}` },
  td: { padding: "8px 10px", color: C.textMid, borderBottom: `1px solid ${C.borderLight}`, fontSize: 13 },
  mono: { fontFamily: "'JetBrains Mono', monospace" },
  
  // Button Styles
  buttonPrimary: {
    padding: "10px 16px",
    background: C.accent,
    color: "#ffffff",
    border: "none",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s ease",
    outline: "none",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    ":hover": {
      background: "#0052a3",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    },
    ":active": {
      transform: "translateY(1px)"
    }
  },
  
  buttonSecondary: {
    padding: "10px 16px",
    background: C.card,
    color: C.text,
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s ease",
    outline: "none",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.02)",
    ":hover": {
      background: C.bg,
      borderColor: C.textMid
    },
    ":active": {
      transform: "translateY(1px)"
    }
  },
  
  buttonDanger: {
    padding: "10px 16px",
    background: C.red,
    color: "#ffffff",
    border: "none",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s ease",
    outline: "none",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    ":hover": {
      background: "#b91c1c",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    },
    ":active": {
      transform: "translateY(1px)"
    }
  }
};

export const planColors = {
  "Plan 1500": C.green,
  "Plan 1200": "#0d9488",
  "Plan 1050": C.blue,
  "Plan 900": C.purple,
  "Plan 750": C.orange,
  "Plan 600": "#e11d48",
};
